import React from "react";
import PropTypes from "prop-types";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import MDModal from "../../MDModal";
import MDButton from "../../MDButton";


const Confirmation = (props) => {
    let footer = null;
    if(!props.saving){
        footer = [
            <MDButton key="cancel" variant="gradient" color="light" onClick={props.onCancel}>
                Cancel
            </MDButton>,
            <MDButton key="confirm" label="" variant="gradient" color="info" onClick={props.onSuccess}>
                Yes
            </MDButton>
        ];
    }
    function onRequestClose(){
        if(props.saving){
            return;
        }
        props.onCancel();
    }
    return (
        <MDModal
            open={props.open}
            footer={footer}
            onClose={onRequestClose}
            title="Confirm"
        >
            {
                props.errorMessage !== null ?
                    <Stack mb={2}>
                        <Alert severity="error">{props.errorMessage}</Alert>
                    </Stack>
                :
                null
            }
            {
                props.saving ?
                    <Box sx={{ display: 'flex' }}>
                        <CircularProgress color="info" />
                    </Box>
                :
                    <Stack mb={2}>
                        {props.message}
                    </Stack>
            }
        </MDModal>
    )
};

Confirmation.defaultProps = {
    item: null,
    message: "Are you sure you want to delete?"
}
Confirmation.propTypes = {
    classes: PropTypes.object,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func,
    open: PropTypes.bool,
    item: PropTypes.object,
    message: PropTypes.string,
    saving: PropTypes.bool,
    errorMessage: PropTypes.string
};

export default Confirmation;